// removed by extract-text-webpack-plugin
module.exports = {"dark-red":"#a30000","red":"#e40000","dark-purple":"#4a2e5e","purple":"#7c4d9e","light-purple":"#a096c8","background-purple":"#eff0f4","dark-orange":"#b55808","orange":"#ef8d07","yellow":"#fdc400","light-green":"#e5f1e5","dark-green":"#008300","green":"#96ba3a","lime":"#d3d000","heavy-blue":"#21242a","dark-blue":"#2e323a","blue":"#2c397f","sky-blue":"#54bfff","black":"#000000","grey":"#707070","medium-grey":"#9f9f9f","light-grey":"#d4d4d4","background-grey":"#f6f6f6","white":"#ffffff"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/styles/_colors.css
// module id = 57
// module chunks = 0